import { servicesQuery } from '@/services/api';
import { useAuth } from '@/services/auth';

export function useCopilotActions() {
  const query = servicesQuery.useQueryClient();
  const auth = useAuth();

  const deleteMutation = servicesQuery.deleteCopilotSession.useMutation({
    onSuccess: () => {
      query.invalidateQueries({ queryKey: ['copilotHistory'] });
    },
  });

  const updateMutation = servicesQuery.updateCopilotSession.useMutation({
    onSuccess: () => {
      query.invalidateQueries({ queryKey: ['copilotHistory'] });
    },
  });

  return {
    deleteSession: async (sessionId: number) => {
      await deleteMutation.mutateAsync({
        params: { accountId: auth.account.id, sessionId },
      });
    },
    renameSession: async (sessionId: number, name: string) => {
      await updateMutation.mutateAsync({
        params: { accountId: auth.account.id, sessionId },
        body: { name },
      });
    },
  };
}
